import moment from 'moment';

const formatter = 'YYYY-MM';
const month = 'month';
const months = 'months';

const dateMillisecondsToMoment = (dateMilliseconds: number) =>
  moment.unix(dateMilliseconds / 1000);

export const getUnixMonth = (dateMilliseconds: number) =>
  dateMillisecondsToMoment(dateMilliseconds).format(formatter);

export const getNextMonth = (dateMilliseconds: number) =>
  dateMillisecondsToMoment(dateMilliseconds)
    .add(1, months)
    .endOf(month)
    .format(formatter);

export const getPrevMonth = (dateMilliseconds: number) =>
  dateMillisecondsToMoment(dateMilliseconds)
    .subtract(1, months)
    .startOf(month)
    .format(formatter);
